<template>
    <input
        ref="input"
        class="rounded-md border-iron-300 shadow-sm focus:border-z-primary-300 focus:ring-z-primary-200 focus:ring-opacity-50 focus:ring"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>

<script>
export default {
    props: ["modelValue"],

    emits: ["update:modelValue"],

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
